import React from 'react'
import { quandoFoi, descreverMensagem, resultadoDoDisparo } from '../../libs/disparos'

// Os disparos recentes da conexão. Clicar numa linha abre o andamento dela.
export default function ListaDeDisparos({ disparos, selecionado, onSelecionar }) {
  if (!disparos.length) return null
  return (
    <section className="dp-anteriores">
      <h4>Recentes</h4>
      <div className="dp-tabela">
        <table>
          <thead>
            <tr><th>Quando</th><th>Mensagem</th><th>Resultado</th></tr>
          </thead>
          <tbody>
            {disparos.map((d) => {
              const id = String(d.disparoId)
              return (
                <tr
                  key={id}
                  className="clicavel"
                  aria-selected={id === String(selecionado)}
                  tabIndex={0}
                  onClick={() => onSelecionar(id)}
                  onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); onSelecionar(id) } }}
                >
                  <td className="num">{quandoFoi(d.criadoEm)}</td>
                  <td>{descreverMensagem(d.mensagem)}</td>
                  <td>{resultadoDoDisparo(d)}</td>
                </tr>
              )
            })}
          </tbody>
        </table>
      </div>
    </section>
  )
}
